import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import classes from './RatingCard.module.scss';

type RatingCardProps = {
  textColor: string;
  className?: string;
  blurredBackground?: boolean;
  children: ReactNode;
};

export const RatingCard: FC<RatingCardProps> = ({
  textColor,
  className,
  blurredBackground = false,
  children,
}) => (
  <div
    className={classNames(classes.card, !blurredBackground && classes.transparent, className)}
    style={{ color: textColor }}
  >
    {children}
  </div>
);
